module.exports = __webpack_public_path__ + "img/view.9fb5a728.svg";